import { render, staticRenderFns } from "./TemplateFieldsPopup.vue?vue&type=template&id=9f5af94c"
import script from "./TemplateFieldsPopup.vue?vue&type=script&lang=js"
export * from "./TemplateFieldsPopup.vue?vue&type=script&lang=js"
import style0 from "./TemplateFieldsPopup.vue?vue&type=style&index=0&id=9f5af94c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports